'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode,
    DAGLink = _require.DAGLink;

var CID = require('cids');

var log = require('debug')('ipfs:mfs:core:utils:remove-link');

var UnixFS = require('ipfs-unixfs');

var _require2 = require('./hamt-utils'),
    generatePath = _require2.generatePath,
    updateHamtDirectory = _require2.updateHamtDirectory;

var errCode = require('err-code');

var mc = require('multicodec');

var mh = require('multihashes');

var removeLink = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, options) {
    var meta;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!options.parentCid && !options.parent)) {
              _context.next = 2;
              break;
            }

            throw errCode(new Error('No parent node or CID passed to removeLink'), 'EINVALIDPARENT');

          case 2:
            if (!(options.parentCid && !CID.isCID(options.parentCid))) {
              _context.next = 4;
              break;
            }

            throw errCode(new Error('Invalid CID passed to removeLink'), 'EINVALIDPARENTCID');

          case 4:
            if (options.parent) {
              _context.next = 9;
              break;
            }

            log("Loading parent node ".concat(options.parentCid));
            _context.next = 8;
            return context.ipld.get(options.parentCid);

          case 8:
            options.parent = _context.sent;

          case 9:
            if (options.name) {
              _context.next = 11;
              break;
            }

            throw errCode(new Error('No child name passed to removeLink'), 'EINVALIDCHILDNAME');

          case 11:
            meta = UnixFS.unmarshal(options.parent.Data);

            if (!(meta.type === 'hamt-sharded-directory')) {
              _context.next = 15;
              break;
            }

            log("Removing ".concat(options.name, " from sharded directory"));
            return _context.abrupt("return", removeFromShardedDirectory(context, options));

          case 15:
            log("Removing link ".concat(options.name, " regular directory"));
            return _context.abrupt("return", removeFromDirectory(context, options));

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function removeLink(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var removeFromDirectory = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context, options) {
    var hashAlg, cid;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            hashAlg = mh.names[options.hashAlg];
            options.parent.rmLink(options.name);
            _context2.next = 4;
            return context.ipld.put(options.parent, mc.DAG_PB, {
              cidVersion: options.cidVersion,
              hashAlg: hashAlg
            });

          case 4:
            cid = _context2.sent;
            log("Updated regular directory ".concat(cid));
            return _context2.abrupt("return", {
              node: options.parent,
              cid: cid
            });

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function removeFromDirectory(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var removeFromShardedDirectory = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context, options) {
    var _yield$generatePath, rootBucket, path, _yield$updateShard, node;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return generatePath(context, options.name, options.parent);

          case 2:
            _yield$generatePath = _context3.sent;
            rootBucket = _yield$generatePath.rootBucket;
            path = _yield$generatePath.path;
            _context3.next = 7;
            return rootBucket.del(options.name);

          case 7:
            _context3.next = 9;
            return updateShard(context, path, {
              name: options.name,
              cid: options.cid,
              size: options.size,
              hashAlg: options.hashAlg,
              cidVersion: options.cidVersion,
              flush: options.flush
            }, options);

          case 9:
            _yield$updateShard = _context3.sent;
            node = _yield$updateShard.node;
            return _context3.abrupt("return", updateHamtDirectory(context, node.Links, rootBucket, options));

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function removeFromShardedDirectory(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

var updateShard = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context, positions, child, options) {
    var _positions$pop, bucket, prefix, node, link, result, newName, size;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _positions$pop = positions.pop(), bucket = _positions$pop.bucket, prefix = _positions$pop.prefix, node = _positions$pop.node;
            link = node.Links.find(function (link) {
              return link.Name.substring(0, 2) === prefix;
            });

            if (link) {
              _context4.next = 4;
              break;
            }

            throw errCode(new Error("No link found with prefix ".concat(prefix, " for file ").concat(child.name)), 'ERR_NOT_FOUND');

          case 4:
            if (!(link.Name === "".concat(prefix).concat(child.name))) {
              _context4.next = 10;
              break;
            }

            log("Removing existing link ".concat(link.Name));
            node.rmLink(link.Name);
            _context4.next = 9;
            return bucket.del(child.name);

          case 9:
            return _context4.abrupt("return", updateHamtDirectory(context, node.Links, bucket, options));

          case 10:
            log("Descending into sub-shard ".concat(link.Name, " for ").concat(prefix).concat(child.name));
            _context4.next = 13;
            return updateShard(context, positions, child, options);

          case 13:
            result = _context4.sent;
            newName = prefix;

            if (result.node.Links.length === 1) {
              log("Removing subshard for ".concat(prefix)); // convert shard back to normal dir

              result.cid = result.node.Links[0].Hash;
              result.node = result.node.Links[0];
              newName = "".concat(prefix).concat(result.node.Name.substring(2));
            }

            log("Updating shard ".concat(prefix, " with name ").concat(newName));
            size = DAGNode.isDAGNode(result.node) ? result.node.size : result.node.Tsize;
            return _context4.abrupt("return", updateShardParent(context, bucket, node, prefix, newName, size, result.cid, options));

          case 19:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function updateShard(_x7, _x8, _x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();

var updateShardParent = function updateShardParent(context, bucket, parent, oldName, newName, size, cid, options) {
  parent.rmLink(oldName);
  parent.addLink(new DAGLink(newName, size, cid));
  return updateHamtDirectory(context, parent.Links, bucket, options);
};

module.exports = removeLink;